/**
 * Serverside tablo filtre dropdown'ları — sayfa verisi değil, BE distinct / lookup.
 */
import { api } from "../api/client";

let _personelCache = null;

/** Takvim personelleri (leaf; departman satırları hariç). */
export async function fetchPersonelFilterNames() {
  if (_personelCache) return _personelCache;
  const { data } = await api.get("/lookups/users", { params: { limit: 2000, scope: "liste" } });
  const names = (data || [])
    .filter((u) => !u.root)
    .map((u) => {
      const ad = (u.ad || `${u.isim || ""} ${u.soyisim || ""}`).trim();
      return ad;
    })
    .filter(Boolean);
  _personelCache = Array.from(new Set(names)).sort((a, b) =>
    a.localeCompare(b, "tr")
  );
  return _personelCache;
}

export async function fetchIsEmriFilterOptions(durum) {
  const { data } = await api.get(
    `/is-emirleri/durum/${encodeURIComponent(durum)}/filter-options`
  );
  return {
    musteri: data?.musteri || [],
    temsilci: data?.temsilci || [],
    durum: data?.durum || [],
  };
}

export async function fetchAllTeklifFilterOptions() {
  const { data } = await api.get("/teklifler/filter-options");
  return {
    musteri: data?.musteri || [],
    temsilci: data?.temsilci || [],
  };
}

export async function fetchTeklifFilterOptions(durum, extra = {}) {
  const { data } = await api.get(
    `/teklifler/durum/${encodeURIComponent(durum)}/filter-options`,
    { params: extra }
  );
  return {
    musteri: data?.musteri || [],
    temsilci: data?.temsilci || [],
  };
}

export async function fetchSatisRaporFilterOptions({ yil, ay } = {}) {
  const { data } = await api.get("/raporlar/teklif-satis/filter-options", {
    params: { yil, ay: ay || undefined },
  });
  return {
    musteri: data?.musteri || [],
    temsilci: data?.temsilci || [],
  };
}

export async function fetchSatisDetayFilterOptions({ baslangic, bitis } = {}) {
  const { data } = await api.get("/raporlar/teklif-satis/detay/filter-options", {
    params: { baslangic, bitis },
  });
  return {
    musteri: data?.musteri || [],
    temsilci: data?.temsilci || [],
    teklif_tipi: data?.teklif_tipi || [],
    urun_tipi: data?.urun_tipi || [],
  };
}

export async function fetchOdemeTakipFilterOptions({ yil, ay } = {}) {
  const { data } = await api.get("/raporlar/odeme-takip/filter-options", {
    params: { yil, ay: ay || undefined },
  });
  return {
    musteri: data?.musteri || [],
    temsilci: data?.temsilci || [],
    para_birimi: data?.para_birimi || [],
    odendi_raw: data?.odendi_raw || ["Ödenmedi", "Ödendi"],
  };
}

/** MUI filterOptions.names — boşsa MUI yine sayfadan üretir; [] veriyoruz + yüklendi bayrağı ekranda. */
export function namesFilterOptions(names, extraLogic) {
  const opts = {
    fullWidth: true,
    names: Array.isArray(names) ? names : [],
  };
  if (typeof extraLogic === "function") {
    opts.logic = extraLogic;
  }
  return opts;
}

/** Kolon options'a yay: serbest metin → serverside ILIKE (UYF/Seri/MSN). */
export const TEXT_FILTER_COL = {
  filter: true,
  filterType: "textField",
  filterOptions: { fullWidth: true },
};

const TEXT_FILTER_NAMES = new Set([
  "uyfler",
  "uyf_no",
  "seri_nolar",
  "seri_no",
  "msn",
]);

/**
 * Sayfa-türevli dropdown yerine facet/lookup names + yüksek kardinalite → textField.
 * tipColumn zaten names taşıyorsa facets.tip yoksa dokunma.
 */
export function applyFilterFacets(columns, facets = {}) {
  const nameMap = {
    musteri: facets.musteri,
    temsilci: facets.temsilci,
    durum: facets.durum,
    teknik_personeller: facets.personel,
    talep_edenler: facets.personel,
    tip: facets.tip,
    teklif_tipi: facets.teklif_tipi,
    urun_tipi: facets.urun_tipi,
    para_birimi: facets.para_birimi,
    odendi_raw: facets.odendi_raw,
  };

  return (columns || []).map((col) => {
    if (!col || !col.options || col.options.filter === false) return col;
    const name = col.name;
    if (TEXT_FILTER_NAMES.has(name)) {
      return {
        ...col,
        options: {
          ...col.options,
          filterType: "textField",
          filterOptions: {
            ...(col.options.filterOptions || {}),
            fullWidth: true,
          },
        },
      };
    }
    const names = nameMap[name];
    if (!Array.isArray(names) || !names.length) return col;
    const prev = col.options.filterOptions || {};
    return {
      ...col,
      options: {
        ...col.options,
        filterOptions: {
          ...prev,
          fullWidth: true,
          names,
        },
      },
    };
  });
}
